<template>
    <v-row
      class="fill-height"
      v-if="!isChangePass"
    >
      <v-container fluid>
        <v-row
          align="center"
          justify="center"
          class="ma-0"
        >
          <v-card
            width="100%"
            elevation="10"
          >
            <v-card-title class="title">Dados Básicos</v-card-title>
            <v-card-text>
              <v-form
                v-model="valid"
              >
                <v-container fluid>
                  <v-row
                    align="center"
                  >
                    <v-col
                      cols="12"
                      md="1"
                      lg="1"
                      xl="1"
                      align="center"
                    >
                      <div class="user-img" @click="openImgInput">
                        <img v-if="profilePicPresignedUrl" :src="profilePicPresignedUrl" />
                        <v-icon size="40px" v-else>mdi-account-circle</v-icon>
                      </div>
                      <p @click="saveImagePath(null, true)" v-if="profilePicPresignedUrl" class="remove-img">Remover imagem</p>
                      <input
                        type="file"
                        ref="imgInput"
                        accept="image/png, image/jpeg"
                        class="img-input"
                        @change="uploadNewImage"
                      >
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="4"
                      xl="4"
                    >
                      <v-text-field
                        v-model="currentFormData.strName"
                        label="Nome"
                        :error-messages="strNameErrors"
                        :disabled="!editMode"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="4"
                      xl="4"
                    >
                      <v-text-field
                        v-model="currentFormData.strEmail"
                        label="E-mail"
                        :error-messages="strEmailErrors"
                        :disabled="!editMode"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      lg="3"
                      xl="3"
                    >
                      <phone-input
                        v-model="currentFormData.strPhoneNumber"
                        label="Telefone"
                        :error-messages="strPhoneNumberErrors"
                        :disabled="!editMode"
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    class="ma-0 my-2"
                  >
                    <v-col
                      cols="12"
                      md="12"
                      lg="12"
                      xl="12"
                    >
                      <p class="img-disclaimer">*Clique no espaço da imagem para alterá-la.</p>
                      <p class="img-disclaimer">*A imagem escolhida aparecerá também nos relatórios gerados.</p>
                    </v-col>
                  </v-row>
                  <v-row
                    class="ma-0 my-2"
                  >
                    <v-spacer/>
                    <div v-if="editMode">
                      <v-btn
                        @click="onCancelEdit"
                        color="error"
                        :disabled="isSaving"
                        outlined
                        class="mx-1"
                      >
                        Cancelar Edição
                      </v-btn>
                      <v-btn
                        @click="onSaveClick"
                        color="success"
                        :loading="isSaving"
                        outlined
                        class="mx-1"
                      >
                        Salvar Edição
                      </v-btn>
                    </div>
                    <div v-else>
                      <v-btn                        
                        @click="ischangePass"
                        color="primary"
                        :disabled="isSaving"
                        outlined
                        class="mx-1"
                      >
                        Alterar senha
                      </v-btn>                      
                      <v-btn                        
                        @click="onStartEdit"
                        color="accent"
                        :disabled="isSaving"
                        outlined
                      >
                        Editar
                      </v-btn>
                    </div>
                  </v-row>                
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </v-row>
    <v-row
      class="fill-height"
      v-else
    >
      <v-container fluid>
        <v-row
          align="center"
          justify="center"
          class="ma-0"
        >
          <v-card
            width="100%"
            elevation="10"
          >
            <v-card-title class="title">Alterar senha</v-card-title>
            <v-card-text>
              <v-form
                v-model="validFormPass"
              >
                <v-container fluid>
                  <v-row
                    align="center"
                  >
                    <v-col
                      cols="12"
                      md="4"
                      lg="4"
                      xl="4"
                    >
                      <v-text-field
                        id="current-password"
                        name="current-password"
                        color="accent"
                        label="Senha atual"
                        outlined
                        class="mx-0"
                        v-model="frmChangePass.str_old_password"
                        :error-messages="oldPasswordErrors"
                        :append-icon="showPasswordOld ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPasswordOld ? 'password': 'text' "
                        @click:append="showPasswordOld = !showPasswordOld"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="4"
                      xl="4"
                    >
                      <v-text-field
                        id="new-password"
                        name="new-password"
                        color="accent"
                        label="Nova senha"
                        outlined
                        class="mx-0"
                        v-model="frmChangePass.str_new_password"
                        :error-messages="newPasswordErrors"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'password': 'text' "
                        @click:append="showPassword = !showPassword"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="4"
                      xl="4"
                    >
                      <v-text-field
                        id="new-password-repeat"
                        name="new-password-repeat"
                        color="accent"
                        label="Repita a nova senha"
                        outlined
                        class="mx-0"
                        v-model="frmChangePass.str_confirme_password"
                        :error-messages="newPasswordRepeatErrors"
                        :append-icon="showPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPasswordRepeat ? 'password': 'text' "
                        @click:append="showPasswordRepeat = !showPasswordRepeat"
                      >
                      </v-text-field>
                    </v-col>                                                 
                  </v-row>
                  <v-row
                    class="ma-0 my-2"
                  >
                    <v-spacer/>
                    <div>
                      <v-btn
                        @click="onCancelChangePass"
                        color="error"
                        :disabled="isSaving"
                        outlined
                        class="mx-1"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        @click="onChangePass"
                        color="success"
                        :loading="isSaving"
                        outlined
                        class="mx-1"
                      >
                        Alterar
                      </v-btn>
                    </div>
                  </v-row>                  
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </v-row>    
</template>

<script>
  import {validationMixin} from "vuelidate"
  import {UserData} from "../../api/api-auth"
  import required from "vuelidate/src/validators/required"
  import {cloneDeep, isEmpty, isNull, isUndefined} from "lodash/lang"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
  import email from "vuelidate/lib/validators/email"
  import minLength from "vuelidate/src/validators/minLength"
  import PhoneInput from "../../components/Helpers/Form/PhoneInput"
  import PhoneNumber from 'awesome-phonenumber';
  import {mapActions} from "vuex"
  import {SET_USER_DATA} from "../../store/modules/user"
  import {AUTH_URL, PROJECT_URL, AWS_KEY, AWS_BUCKET, ENVIRONMENT} from "./../../globals"
  import {PicUploaderEventBus} from "../../helpers/upload/events"

  const Evaporate = require('evaporate')
  const crypto = require('crypto')
  const AWS = require('aws-sdk')

  export default {
    name: "UserProfile",
    components: {PhoneInput},
    mixins: [validationMixin],
    data: () => ({
      profilePicture: null,
      profilePicPresignedUrl: null,
      pictureUploadPath: "profile-pictures/",
      editMode: false,
      isSaving: false,
      isChangePass: false,

      showPasswordOld: true,
      showPassword: true,
      showPasswordRepeat: true,


      valid: false,
      validFormPass: false,
      currentFormData: {
        strName: null,
        strEmail: null,
        strPhoneNumber: null,
      },
      lastFormData: {
        strName: null,
        strEmail: null,
        strPhoneNumber: null,
      },

      frmChangePass: {
        str_old_password: null,
        str_new_password: null,
        str_confirme_password: null
      },

      referralLink: null,
      isLinkInClipboard: false,
    }),
    validations: {
      frmChangePass: {
        str_old_password: {
          required,
        },
        str_new_password: {
          required,
          minLength: minLength(5)
        },
        str_confirme_password: {
          required,
          minLength: minLength(5)
        },                        
      },
      currentFormData: {
        strName: {
          required,
        },
        strEmail: {
          required,
          email
        },
        strPhoneNumber: {
          required,
          isValid: function () {
            return this.currentFormData.strPhoneNumber.isValid()
          }
        }
      },
    },
    methods: {
      ischangePass() {
        this.isChangePass = true
      },
      onChangePass() {
        this.$v.frmChangePass.$touch()
        if (this.$v.frmChangePass.$invalid) return

        if (this.frmChangePass.str_new_password !== this.frmChangePass.str_confirme_password) {
          this.$notify(new NotificationOptions({
            message: "Nova senha e confirmação não conferem.",
            type: NOTIFICATION_TYPES.WARNING,
          })) 
          return         
        }

        this.$apiAuth.changePasswordNew(this.frmChangePass.str_old_password, this.frmChangePass.str_new_password)
        .then(() => {
          this.$notify(new NotificationOptions({
            message: "Senha alterada com sucesso!",
            type: NOTIFICATION_TYPES.SUCCESS,
          })) 
          this.onCancelChangePass()
        })
        .catch((err) => {
          console.log(err)
          this.$notify(new NotificationOptions({
            message: "Não foi possível alterar sua senha. Confira os dados e tente novamente.",
            type: NOTIFICATION_TYPES.ERROR,
          }))            
        })
      },
      onCancelChangePass() {
        this.isChangePass = false
        this.frmChangePass.str_old_password = null
        this.frmChangePass.str_new_password = null
        this.frmChangePass.str_confirme_password = null        
      },
      onSaveClick() {
        this.$v.currentFormData.$touch()

        if (this.$v.currentFormData.$invalid) return

        const pb = this.currentFormData.strPhoneNumber.toJSON()
        const userData = {
          str_name: this.currentFormData.strName,
          str_email: this.currentFormData.strEmail,
          str_phone_number: pb.number["significant"],
          ab_phone_region: pb["regionCode"],
          ab_country: pb["regionCode"].toUpperCase(),
        }
        this.isSaving = true
        this.$apiAuth.updateUser(userData)
          .then((res) => {
            this.editMode = false
            const userData = UserData.fromObject(res.data)
            this.setUserData(userData)
            this.$notify(new NotificationOptions({
              message: "Dados atualizados com sucesso",
              type: NOTIFICATION_TYPES.SUCCESS,
            }))
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Erro ao atualizar dados do usuário",
              type: NOTIFICATION_TYPES.ERROR,
            }))
          })
          .finally(() => {
            this.isSaving = false
          })
      },
      onStartEdit() {
        this.lastFormData = cloneDeep(this.currentFormData)
        this.editMode = true
      },
      onCancelEdit() {
        this.currentFormData = this.lastFormData
        this.editMode = false
      },
      createReferralLink() {
        this.$apiAuth.createReferralToken()
          .then((res) => {
            if (!res.data) {
              this.$notify(new NotificationOptions({
                message: "Erro ao gerar o link de indicação",
                type: NOTIFICATION_TYPES.ERROR,
              }))
            }

            const referralToken = res.data.cd_referral_token
            if (!referralToken) {
              this.$notify(new NotificationOptions({
                message: "Erro ao gerar o link de indicação",
                type: NOTIFICATION_TYPES.ERROR,
              }))
            }

            const curUrl = new URL(document.URL)
            this.referralLink = `${curUrl.origin}/register?rft=${referralToken}`
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Erro ao gerar o link de indicação",
              type: NOTIFICATION_TYPES.ERROR,
            }))
          })
      },
      copyTextToClipboard(text) {
        if (!navigator.clipboard) {
          this.fallbackCopyTextToClipboard(text);
          return;
        }
        navigator.clipboard.writeText(this.referralLink).then(function () {
          console.log('Async: Copying to clipboard was successful!');
        }, function (err) {
          console.error('Async: Could not copy text: ', err);
        });
      },

      fallbackCopyTextToClipboard() {
        // Reference: https://ourcodeworld.com/articles/read/143/how-to-copy-text-to-clipboard-with-javascript-easily
        this.$refs["copy-el"].focus()
        this.$refs["copy-el"].select()
        let copyStatus = false
        try {
          copyStatus = document.execCommand('copy');
          const msg = copyStatus ? 'successful' : 'unsuccessful';
          console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
        }
        this.isLinkInClipboard = Boolean(copyStatus)
      },
      ...mapActions({
        setUserData: SET_USER_DATA
      }),
      openImgInput() {
        this.$refs.imgInput.click();
      },
      async getUserImg() {
        const authToken = this.$apiAuth.getAuthToken();
        const userId = this.$store.state.user.userData.idUserAccount;
        const rawResponse = await fetch(`${PROJECT_URL}/projects/generate-picture-presigned-url/?userid=${userId}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`
          },
        });
        const content = await rawResponse.json();
        if (content.presigned_url) {
          this.profilePicPresignedUrl = content.presigned_url;
        }
      },
      async saveImagePath(path, deleting=false) {
        const authToken = this.$apiAuth.getAuthToken();
        let data = {
            id_user_account: this.$store.state.user.userData.idUserAccount,
            str_profile_picture: path
        }
        if (deleting) {
          this.profilePicPresignedUrl = null;
          const deleteResponse = await fetch(`${PROJECT_URL}/processings/delete-image-profile-user/`, {
            method: 'DELETE',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });
          const contentDel = await deleteResponse.json();
          console.log(contentDel)  
          if (contentDel.success == "delete-picture-success"){
            PicUploaderEventBus.$emit("profile-pic-deleted");
            this.$notify(new NotificationOptions({
              message: "Imagem de perfil removida!",
              type: NOTIFICATION_TYPES.SUCCESS,
            }))
            return;
          }
        } else {
          const rawResponse = await fetch(`${AUTH_URL}/users/save-user-pic-path/`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          });
          const content = await rawResponse.json();
          if (content.data.profile_pic_path) {
            this.getUserImg()
            PicUploaderEventBus.$emit("profile-pic-changed");
          }
        }        
      },
      async uploadNewImage() {
        this.profilePicture = this.$refs.imgInput.files;

        const authToken = this.$apiAuth.getAuthToken();
        await fetch(`${PROJECT_URL}/processings/delete-image-profile-user/`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });
        
        const uploader = Evaporate.create({
          signerUrl: PROJECT_URL+"/projects/get-presigned-url/",
          signHeaders: {"Authorization": "Bearer " + authToken},
          aws_key: AWS_KEY,
          aws_url: "https://horus-platform.s3.amazonaws.com",
          bucket: AWS_BUCKET,
          cloudfront: true,
          logging: false,
          computeContentMd5: true,
          sendCanonicalRequestToSignerUrl: false,
          maxFileSize: 100000000000,
          cryptoHexEncodedHash256: function (data) { return crypto.createHash('sha256').update(data).digest('hex'); },
          cryptoMd5Method: function (data) { return AWS.util.crypto.md5(data, 'base64') }
        })

        const file = this.profilePicture[0];
        const extension = file.name.split('.').pop()

        const env = `${ENVIRONMENT}/`

        const profilePicture = `${this.$store.state.user.userData.idUserAccount}.${extension}`

        const path = this.pictureUploadPath + env + profilePicture

        uploader.then((evaporate) => {
          evaporate.add({
            file,
            name: path,
            progress: () => {},
            complete: () => {
              console.log("Upload complete")
              this.saveImagePath(path);
              this.$notify(new NotificationOptions({
                message: "Imagem de perfil atualizada!",
                type: NOTIFICATION_TYPES.SUCCESS,
              }))
            },
            error: () => {
              this.$notify(new NotificationOptions({
                message: "Houve um problema com o upload da imagem. Tente novamente mais tarde.",
                type: NOTIFICATION_TYPES.ERROR,
              }))
            },
          }).then(
            () => {},
            () => {}
          );
        })
      },
    },
    created() {
      this.$appMng.setTitle("Meus dados")
      this.$apiAuth.whoami()
        .then((response) => {
          const userData = UserData.fromObject(response.data)
          this.currentFormData.strName = userData.strName
          this.currentFormData.strEmail = userData.strEmail
          this.currentFormData.strPhoneNumber = new PhoneNumber(userData.strPhoneNumber, userData.abPhoneRegion)

          this.$appMng.setIsLoadingPage(false)
        })
        this.getUserImg();
    },
    computed: {
      strNameErrors() {
        const errors = []
        if (!this.$v.currentFormData.strName.$dirty) return errors
        !this.$v.currentFormData.strName.required && errors.push("Esse campo é obrigatório")
        return errors
      },
      strEmailErrors() {
        const errors = []
        if (!this.$v.currentFormData.strEmail.$dirty) return errors
        !this.$v.currentFormData.strEmail.required && errors.push("Esse campo é obrigatório")
        !this.$v.currentFormData.strEmail.email && errors.push("E-mail inválido")
        return errors
      },
      strPhoneNumberErrors() {
        const errors = []
        if (!this.$v.currentFormData.strPhoneNumber.$dirty) return errors
        !this.$v.currentFormData.strPhoneNumber.required && errors.push("Esse campo é obrigatório")
        !this.$v.currentFormData.strPhoneNumber.isValid && errors.push("Telefone inválido")
        return errors
      },
      oldPasswordErrors() {
        const errors = []
        if (!this.$v.frmChangePass.str_old_password.$dirty) return errors
        !this.$v.frmChangePass.str_old_password.required && errors.push("Esse campo é obrigatório")        
        return errors
      },
      newPasswordErrors() {
        const errors = []
        if (!this.$v.frmChangePass.str_new_password.$dirty) return errors
        !this.$v.frmChangePass.str_new_password.required && errors.push("Esse campo é obrigatório")
        !this.$v.frmChangePass.str_new_password.minLength && errors.push("Nova senha deve conter mais de 4 caracteres")       
        return errors
      },
      newPasswordRepeatErrors() {
        const errors = []
        if (!this.$v.frmChangePass.str_confirme_password.$dirty) return errors
        !this.$v.frmChangePass.str_confirme_password.required && errors.push("Esse campo é obrigatório")
        !this.$v.frmChangePass.str_confirme_password.minLength && errors.push("Confirmação de senha deve conter mais de 4 caracteres")       
        return errors
      },              
      referralLinkIsEmpty() {
        if (isEmpty(this.referralLink) || isNull(this.referralLink) || isUndefined(this.referralLink)) return true
        return this.referralLink === ""
      },
      linkInClipboardText() {
        if (this.isLinkInClipboard) return "Copiado!"
        return "Copiar Link"
      },
      indicationMainText() {
        return "Indique a Mappa para seus amigos!"
      },
      indicationExtraText() {
        return "Basta gerar o link ao lado e compartilhar!"
      },
      copyLinkButtonColor() {
        return this.isLinkInClipboard ? "success" : "accent"
      }
    },
  }
</script>

<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .25s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  .user-img {
    height: 80px;
    width: 80px;
    background: #b2cbd6;
    display: grid;
    place-items: center;
    cursor: pointer;
    img {
      height: 100%;
      width: 100%;
    }
  }

  .img-input {
    display: none;
  }

  .img-disclaimer {
    margin: 0;
    font-size: 12px;
  }

  .remove-img {
    margin: 0;
    font-size: 12px;
    cursor: pointer;
    color: #005378;
  }
</style>
